const LINK_CLICK_TYPES = {
  WIDGET: 'WIDGET',
  CONTENT: 'CONTENT',
  SOCIAL_BUTTON: 'SOCIAL_BUTTON',
};

export default LINK_CLICK_TYPES;
